<div *ngIf="syncCompleted" class="page-layout carded left-sidenav toolbar-fixed-layout">
  <particle-breadcumb-tab-action
    *ngIf="viewType=='Compact'"
    [breadcrumbs]="breadcrumbs"
    [tabs]="tabs"
    [selectedTab]="selectedTab"
    [actions]="actions"
    (viewTypeChanged)="viewTypeChanged($event)"
    (selectedTabChanged)="onSelectedTabChanged($event)"
  >
  </particle-breadcumb-tab-action>

  <div *ngIf="viewType!='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-row justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
      <button class="view-change" (click)="compactViewType()">
        <i class="fas fa-expand-alt"></i>
      </button>
    </div>
  </div>

  <div *ngIf="viewType!=='Compact'" class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">

        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="manageTransactions()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="add-section"
          >Manage Transactions
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <!--        <div class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          <particle-grid-apply-filter [filterId]="filterId"-->
        <!--                                      [endpointName]="endpoint"-->
        <!--                                      [invalidateSubject] = "invalidateSubject">-->
        <!--          </particle-grid-apply-filter>-->

        <!--          <div class="toolbar-separator m-l-10"></div>-->
        <!--        </div>-->
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="manageSection('Dac6-Transaction')"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="manage-fields"
          >Manage Fields
          </button>

          <div class="toolbar-separator"></div>
        </div>
        <div class="button-container flex flex-row justify-start items-center">
          <button mat-button class="orbitax-flat-button" (click)="exportTransaction()"
                  particleAnalytics
                  analyticsCategory="entity-transactions-content"
                  analyticsAction="export-tranactions"
          >Export
          </button>

          <div class="toolbar-separator"></div>
        </div>
      </div>
    </div>
    <!--<div fxLayout="column" fxLayoutAlign="center start" class="grid-toolbar-buttons-group-container">
      <div class="grid-toolbar-buttons-group-without-label" fxLayout="row" fxLayoutAlign="start center">
        <button mat-button class="submit-changes" (click)="startDataSurvey()"><i class="fas fa-share"></i> Start Data Survey
        </button>
      </div>
    </div>-->
  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <!--<div particleHelpNotes helpNoteId="dac6-transactions" class="content-card mat-white-bg">
        &lt;!&ndash; CONTENT TOOLBAR &ndash;&gt;

        <div class="content pos-relative" fxLayout="column"  [ngClass]="hasNoExtraTab?'m-30':''">
          <div class="keno-grid-container">
            <particle-virtual-grid
              [sourceKey]="sourceConfigKey"
              sortFieldKey="TransactionCode"
              sortDirection="desc"
              prefixSortFieldKey="FieldValues."
              [sortEnabled]="true"
              [invalidateSubject]="invalidateSubject"
              (valueChanged)="onSelectionChanged($event)"
              [viewType]="viewType"
              (fieldSectionChanged)="onFieldSectionChanged($event)"
              serviceName="TransactionDynamicItemService"
              api="DAC6Api"
            > </particle-virtual-grid>
          </div>
        </div>


      </div>-->
      <div particleHelpNotes helpNoteId="dac6-transactions" class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->
        <div class="content pos-relative p-0 flex flex-col full-grow-no-shrink-no-basis">
          <mat-tab-group [ngClass]="viewType=='Compact'? 'tab-header-hide':''" class="full-grow-no-shrink-no-basis"
                         (selectedIndexChange)="onTabIndexChange($event)" [selectedIndex]="selectedFieldSectionIndex">
            <mat-tab *ngFor="let tab of tabs" [label]="tab.header">
              <div class="keno-grid-container m-30">
                <particle-virtual-grid [sourceKey]="tab.sourceKey" *ngIf="selectedFieldSectionIndex === tab.index"
                                       [invalidateSubject]="tab.invalidateSubject"
                                       sortFieldKey="FieldValues.CaseId"
                                       prefixSortFieldKey="FieldValues."
                                       sortDirection="desc"
                                       (valueChanged)="onSelectionChanged($event)"
                                       serviceName="{{tab.serviceName}}"
                                       api="DAC6Api"
                >
                </particle-virtual-grid>
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
